import { Badge, cn } from "@devhop/ui";
import type { MeetingActionStatus } from "@/modules/management/meeting-minutes/domain/types";

export const MEETING_ACTION_STATUS_LABELS: Record<MeetingActionStatus, string> =
  {
    pending: "ລໍຖ້າ",
    done: "ສຳເລັດ",
  };

/** pending = amber, done = emerald — ໃຊ້ຮ່ວມກັນທັງຕາຕະລາງ ແລະ modal ລາຍລະອຽດ */
function meetingActionStatusBadgeClassName(
  status: MeetingActionStatus,
): string {
  switch (status) {
    case "pending":
      return "border-amber-500/30 bg-amber-500/15 text-amber-800 dark:text-amber-200";
    case "done":
      return "border-emerald-500/30 bg-emerald-500/15 text-emerald-800 dark:text-emerald-200";
    default:
      return "";
  }
}

type MeetingActionStatusBadgeProps = {
  status: MeetingActionStatus;
  className?: string;
};

export function MeetingActionStatusBadge({
  status,
  className,
}: MeetingActionStatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "font-medium",
        meetingActionStatusBadgeClassName(status),
        className,
      )}
    >
      {MEETING_ACTION_STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
